import { useState, useEffect } from "react";

// react-router components
import { useLocation, useNavigate } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React example components
import Sidenav from "features/Sidenav";
import PaymentResultModal from "features/PaymentSetUp/PaymentResultModal";

// Material Dashboard 2 React themes
import theme from "assets/theme";

// Material Dashboard 2 React routes
import routes from "routes";

// Material Dashboard 2 React contexts
import { useMaterialUIController, setMiniSidenav } from "context";

// Images
import brandWhite from "assets/images/whiteicon.png";
import { Providers } from "./providers";
import AppWrapperRoute from "withWrapper/withRouteWrapper";

const App = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const { pathname } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(true);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    if (location.pathname === "/payment/success") {
      setPaymentSuccess(true);
      setResultModalOpen(true);
    } else if (location.pathname === "/payment/cancel") {
      setPaymentSuccess(false);
      setResultModalOpen(true);
    } else {
      setResultModalOpen(false);
    }
  }, [location.pathname]);

  const handleCloseResultModal = () => {
    setResultModalOpen(false);
    navigate("/", { replace: true }); // Redirect to home or dashboard
  };

  return (
    <ThemeProvider theme={theme}>
      <Providers>
        <CssBaseline />
        <PaymentResultModal
          open={resultModalOpen}
          success={paymentSuccess}
          onClose={handleCloseResultModal}
        />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brandWhite}
              brandName="StmpZ"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            {/* <Notification /> */}
          </>
        )}
        <AppWrapperRoute />
      </Providers>
    </ThemeProvider>
  );
};

export default App;
